import $ from 'jquery';

export class Accordion {
  constructor() {}

  setup() {
    $('.js-visionToggle__head').on('click', function () {
      const accordion = $(this).parent().parent();
      const content = $(this).parent().next();

      accordion.toggleClass('-open');
      content.slideToggle();

      if (accordion.hasClass('-open')) {
        content.removeAttr('hidden');
      } else {
        content.prop('hidden', true);
      }
    });
  }
}
